<template>
  <div class="dashboard pad-to-15">
    <!--Stats cards-->
    <div class="row" v-if="showLocations">
      <div class="col-sm-12">
        <div class="">
          <span class="pad-rg-5">{{$t('dashboard.selectLocation')}}</span> 
          <select class="form-control inline-auto white " @change="filterLocations" v-model="selectedLocation">
            <option value=""> - {{$t('general.all')}} - </option>
            <template v-for="(loc, key) in locations" >
              <option  :label="loc.name"
                            :value="loc.id"
                            :key="loc.id"
                            > {{loc.name}}
              </option>
            </template>
          </select>
        </div>
      </div>
    </div>
    <div class="row pad-to-15 all-cards">
      <div :class="cardsClass" v-for="stats in statsCards">
        <stats-card>
          <div class="icon-big text-center"  slot="header">
            <img :src="`/static/img/icons/${stats.icon}`">
          </div>
          <div class="numbers" slot="content">
            <p>{{stats.title}}</p>
            {{stats.value}}
            <small v-if="stats.canceled">( {{stats.canceled}} {{$t('ordersStatus.CANCELED')}})</small>
          </div>
          <div class="stats" slot="footer">
            <i :class="stats.footerIcon"></i> {{stats.footerText}}
          </div>
        </stats-card>
      </div>
    </div>
    <div class="row text-left">
      <!-- Orders Chart -->
      <div class="col-md-12">
        <chart-card :chart-data="ordersChart.data" :chart-options="ordersChart.options" ref="refOrdersChart">
          <div slot="header">
            <h4 class="card-title">{{$t('dashboard.orderChart')}}</h4>
            <p class="category">{{$t('dashboard.today')}}</p>
          </div>
          <div slot="footer">
            <div class="chart-legend">
              <i class="fa fa-circle text-info"></i> {{$t('dashboard.completed')}}
              <!-- <i class="fa fa-circle text-warning"></i> {{$t('dashboard.canceled')}} -->
            </div>
          </div>
        </chart-card>
      </div>
      <!-- Sales chart -->
      <div class="col-md-12">
        <chart-card :chart-data="salesChart.data" :chart-options="salesChart.options" ref="salesChart">
          <div slot="header">
            <h4 class="card-title">{{$t('dashboard.salesChart')}}</h4>
            <p class="category">{{$t('dashboard.today')}}</p>
          </div>
          <div slot="footer">
            <div class="chart-legend">
              <i class="fa fa-circle text-info"></i> {{$t('dashboard.salesIn')}} {{currency}}
            </div>
          </div>
        </chart-card>
      </div>
    </div>
    
    <div class="row text-left">
      <div class="col-md-6">
        <chart-bars-card :chart-data="topProdsChart.data" :chart-options="topProdsChart.options" ref="topProdsChart">
          <div slot="header">
            <h4 class="card-title">{{$t('dashboard.top5Chart')}}</h4>
            <p class="category">{{$t('dashboard.today')}}</p>
          </div>
          <div slot="footer">
            <div class="chart-legend">
              <i class="fa fa-circle text-info"></i> {{$t('dashboard.salesIn')}} {{currency}}
            </div>
          </div>
        </chart-bars-card>
      </div>
      <div class="col-md-6">
        <chart-bars-card :chart-data="deliveryChart.data" :chart-options="deliveryChart.options" ref="deliveryChart">
          <div slot="header">
            <h4 class="card-title">{{$t('dashboard.orderingChart')}}</h4>
            <p class="category">{{$t('dashboard.today')}}</p>
          </div>
          <div slot="footer">
            <div class="chart-legend">
              <i class="fa fa-circle text-info"></i> {{$t('dashboard.nrOfOrders')}}
            </div>
          </div>
        </chart-bars-card>
      </div>
    </div>

  </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn} from 'element-ui'
  import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard.vue'
  import ChartBarsCard from 'src/components/UIComponents/Cards/ChartBarsCard.vue'
  import ChartPieCard from 'src/components/UIComponents/Cards/ChartPieCard.vue'
  // import Loading from 'src/components/Dashboard/Layout/LoadingMainPanel.vue'

  Vue.use(Table)
  Vue.use(TableColumn)

  export default {
    components: {
      StatsCard,
      ChartCard,
      CircleChartCard,
      ChartPieCard,
      ChartBarsCard
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    created () {
      console.warn(this.tableData)
      this.locations = this.$session.get('selectedCompanyData').locations_details
      if (this.locations.length > 1) {
        this.showLocations = true
        let filterCookie = this.$cookie.get('filter-locations')
        if (filterCookie) {
          filterCookie = JSON.parse(filterCookie)
          this.selectedLocation = filterCookie[0]
        }
      }
      this.getData(this.selectedLocation)
    },
    data () {
      return {
        currency: this.getCurrencySymbol(this.$session.get('selectedCompanyData')['currency_iso']),
        locations: [],
        showLocations: false,
        selectedLocation: '',
        cardsClass: 'col-lg-3 col-sm-12',
        statsCards: {
          'new_orders': {
            type: 'warning',
            icon: 'dash1.png',
            title: this.$t('dashboard.tile1Title'),
            value: '',
            footerText: this.$t('dashboard.today'),
            footerIcon: 'ti-calendar'
          },
          'total_orders': {
            type: 'success',
            icon: 'dash2.png',
            title: this.$t('dashboard.tile2Title'),
            value: '',
            canceled: '',
            footerText: this.$t('dashboard.today'),
            footerIcon: 'ti-calendar'
          },
          'revenue': {
            type: 'danger',
            icon: 'dash3.png',
            title: this.$t('dashboard.tile3Title'),
            value: '',
            footerText: this.$t('dashboard.today'),
            footerIcon: 'ti-calendar'
          },
          'installed_apps': {
            type: 'info',
            icon: 'dash4.png',
            title: this.$t('dashboard.tile4Title'),
            value: '',
            footerText: this.$t('dashboard.today'),
            footerIcon: 'ti-calendar'
          }
        },
        ordersChart: {
          data: {
            labels: [],
            series: [],
            canceled: [],
            delivered: []
          },
          options: {
            seriesBarDistance: 10,
            axisX: {
              showGrid: false
            },
            height: '200px'
          }
        },
        salesChart: {
          data: {
            labels: ['9:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00'],
            series: []
          },
          options: {
            showArea: true,
            height: '200px',
            axisX: {
              showGrid: false
            },
            showLine: true
          }
        },
        topProdsChart: {
          title: 'Today',
          data: {
            labels: ['Cappucinno', 'Ristretto', 'Expresso', 'Ice coffe', 'Cookie'],
            series: [
              [411, 345, 201, 189, 157]
            ]
          },
          options: {
            seriesBarDistance: 10,
            showArea: true,
            height: '245px',
            axisX: {
              showGrid: false
            }
          }
        },
        deliveryChart: {
          title: 'Today',
          data: {
            labels: ['Pick-up', 'Meet me half-way', 'On Location', 'Delivery'],
            series: [
              [411, 345, 201, 189]
            ]
          },
          options: {
            seriesBarDistance: 10,
            showArea: true,
            height: '245px',
            axisX: {
              showGrid: false
            }
          }
        }
      }
    },
    methods: {
      filterLocations () {
        this.getData(this.selectedLocation)
        this.$cookie.set('filter-locations', JSON.stringify([this.selectedLocation]), 1)
      },
      getData (location) {
        var self = this
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        if (location && location !== '') {
          data.location = location
          this.cardsClass = 'col-lg-4 col-sm-12'
        } else {
          this.cardsClass = 'col-lg-3 col-sm-12'
        }
        this.apiRequest('/reports/dashboard', 'GET', data, function (response) {
          if (response.status === true) {
            console.warn(response.data)
            self.ordersChart.data.labels = response.data.orders.labels
            self.ordersChart.data.series = [response.data.orders.delivered]
            self.$refs.refOrdersChart.initChart()

            self.salesChart.data.labels = response.data.sales.labels
            self.salesChart.data.series = [response.data.sales.values]
            self.$refs.salesChart.initChart()

            self.topProdsChart.data.labels = response.data.top_products.labels
            self.topProdsChart.data.series = [response.data.top_products.values]
            self.$refs.topProdsChart.initChart()

            self.deliveryChart.data.labels = response.data.delivery_types.labels
            self.deliveryChart.data.series = [response.data.delivery_types.values]
            self.$refs.deliveryChart.initChart()

            self.statsCards.new_orders.value = response.data.counters.new_orders
            self.statsCards.total_orders.value = response.data.counters.total_orders
            self.statsCards.total_orders.canceled = response.data.counters.total_canceled
            self.statsCards.revenue.value = response.data.counters.revenue
            self.statsCards.installed_apps.value = response.data.counters.installed_apps
          }
        })
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dashboard/Overview.vue